
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="margin-bottom-10px font-familyhead">Consumption Entry</label>
          </div>
        </div>
        
        <!--<div class="col-print-12">
          <div class="row bordertop margin-right-0px">
            <div class="col-print-6"></div>
            <div class="col-print-6 text-align-end">
              <label class="margin-bottom-0px font-family font-weight-normal" *ngIf="SelectedFromDate">Date: {{SelectedDateNew| date:'MMM-dd-yyyy'}}</label>
            </div>
          </div>
        </div>-->

        <div class="col-print-12">
          <div class="row bordertop margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead class="">
                      <tr>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-35px padding-right-0px padding-left-0px">
                          #
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Cons.No
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          PID
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <!--<th class="text-align-center">
        Old Reg No
      </th>-->
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family padding-left-0px padding-right-0px">
                          Name
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>



                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Entry By
                        </th>
                        <!--<th class="">
                          Consumed For
                        </th>-->
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                        Status
                        </th>


                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                        Remarks
                        </th>
                        <!--<th></th>-->



                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentMaterialConsumptionEntries2Controller; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center padding-right-0px padding-left-0px">
                          {{RowIndex+1}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.EntryCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.PatientFormattedCode}}</td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left padding-right-0px padding-left-0px">{{l.PatientName}}</td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.EntryDate | date:'MMM-dd-yyyy'}}</td>


                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.EntryUserName}}</td>
                        <!--<td class="td-padding-tb "></td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.AdjustmentStatus}}</td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.Remarks}}</td>







                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
